import { render, staticRenderFns } from "./GroupTeamCreateOrEditForm.vue?vue&type=template&id=e5f4ae28&scoped=true&"
import script from "./GroupTeamCreateOrEditForm.vue?vue&type=script&lang=js&"
export * from "./GroupTeamCreateOrEditForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupTeamCreateOrEditForm.vue?vue&type=style&index=0&id=e5f4ae28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f4ae28",
  null
  
)

export default component.exports